import { List, Map } from 'immutable'
import qs from 'qs'
import {
  Action,
  any,
  async, AsyncState,
  browserRouter,
  Fun,
  IOWidget, loadingAsyncState,
  mk_pair, none,
  nothing,
  Option,
  Pair,
  some, unloadedAsyncState,
  Widget
} from 'widgets-for-react'
import { createButtonData, unescapeHTML } from '../../utils'
import { BlocksRenderer } from '../cms/blocks/block_to_widget.gen'
import { linkWrapper } from '../cms/blocks/utils.gen'
import { DownloadBlockStyle } from '../cms/blocks/widgets/downloadBlock.gen'
import { Page } from '../cms/page/types.gen'
import { ExtraParameters } from '../cms/router/type.gen'
import { AppState, PageTemplateState } from '../cms/state/types.gen'
import { PageStateZero } from '../cms/state/utils.gen'
import { EntryClient } from '../cms/widget.gen'
import { getFormState } from '../form/api'
import {
  ContentType, defaultPage,
  emptyAppState, HeaderState,
  OptionsState, PublicSiteState
} from '../public_site.main.mod'
import { WordPressBlockImagesLoader } from '../wordpress/rendering/image_utils.mod'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import { Breadcrumb } from '../wordpress/types_and_parser/extra_types.mod'
import { Block } from '../wordpress/types_and_parser/standard_blocks.gen'
import { ParsedNode } from '../wordpress/types_and_parser/types.ext.gen'
import { WordPress } from '../wordpress/wordpress_api'
import { TransformStandardBlock, WordPressBlock_To_WidgetBlock } from '../wordpress/wordpress_to_cms.gen'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { BarometerBlockStyle, GraphProps } from './blocks/custom_blocks/widgets/barometer'
import { CarouselBlockItem } from './blocks/custom_blocks/widgets/carouselBlock'
import { GridBlockItem } from './blocks/custom_blocks/widgets/gridBlock.mod'
import { GridHighlightsBlockItem, GridHighlightsBlockStyle } from './blocks/custom_blocks/widgets/gridHighlightsBlock'
import { StringToHeaderType } from './blocks/custom_blocks/widgets/headerBlock.mod'
import { ImageGalleryBlockStyle } from './blocks/custom_blocks/widgets/imageGalleryBlock'
import { LinkProps } from './blocks/custom_blocks/widgets/linkBlock'
import { frieslandcampina_corporate_map, get_addresses } from './blocks/custom_blocks/widgets/mapBlock'
// import { cookiebar } from './templates/cookiebar.mod'
import { MediaBlockStyle } from './blocks/custom_blocks/widgets/mediaBlock'
import { QuoteBlockStyle } from './blocks/custom_blocks/widgets/quoteBlock'
import { StepsBlockStyle } from './blocks/custom_blocks/widgets/stepsBlock'
import { TextBlockStyle } from './blocks/custom_blocks/widgets/textBlock'
import { pageDisplay } from './blocks/renderer.mod'
import {
  carouseBlockClasses, ctaBlockClasses, downloadBlockClasses,
  formBlockClasses, iframeBlockClasses, mediaBlockClasses,
  quoteBlockClasses,
  tableBlockClasses, textBlockClasses
} from './blocks/style.mod'
import { CustomPages, PublicSiteCustomRoutes } from './custom_pages/types.mod'
import { history } from './templates/history.mod'
import { RegionSwitchState } from './templates/regionSwitch/regionSwitchState.mod'
import { sidenote } from './templates/sidenote.mod'
import { countries_list, countries_list_de, countries_list_nl } from './utils/countries.mod'
import { ExtraImages } from './utils/extra_images.mod'

export const defaultLang: string = "en";
export let lang: string = defaultLang;
export const availableLanguages: LanguageType[] = [
  { short: 'nl', full: 'Nederlands' },
  { short: 'en', full: 'English' },
  { short: 'de', full: 'German' },
  { short: 'ng', full: 'Nigerian' }
]

export type LanguageType = {
  short: string,
  full: string
}

export type PublicSite_CustomPageData = {
  posts: Map<number, AsyncState<WordPress.PostTypeResponse>>
  post: WordPress.PostTypeResponse
  latest_articles: AsyncState<Array<WordPress.PostTypeResponse>>
  news: WordPress.Overview<'news'>
  stories: WordPress.Overview<'story'>
  extra_params?: ExtraParameters
}

const removeLangFromSlug = (slug, lang) => {
  if (slug) {
    var pathArray = slug.split('/');
    if (!pathArray[0]) pathArray.shift();
    if (pathArray[0] == lang && (lang == "nl" || lang == "de" || lang == 'ng')) {
      lang = pathArray[0]
      pathArray.shift();
    }
    slug = `/${pathArray.join('/')}`
  }
  return slug
}

export const langToUrl = (lang) =>
  lang  == 'en' ? '/' : `/${lang}`

const closeSearchAndMenu = s1 => (
  {
    ...s1,
    state: {
      ...s1.state,
      header: {
        ...s1.state.header,
        menu: 'closed',
        hoveredItem: null,
        showSearchBar: false
      }
    }
  }
)

export function asyncPost<PT>(id: number, lang: string): AsyncState<WordPress.PostTypeResponse> {
  return loadingAsyncState<WordPress.PostTypeResponse>(_ =>
    WordPress.api()
      .anypost(id)
      .then(response =>
        response.data ? { kind: 'result', status: 200, value: response.data } : { kind: 'failed', status: 404 }
      )
  )
}

export function asyncPosts(args?: WordPress.PostRequestArguments): AsyncState<Array<WordPress.PostTypeResponse>> {
  return loadingAsyncState<Array<WordPress.PostTypeResponse>>(_ =>
    WordPress.api<WordPress.PostTypeResponse>()
      .select('post')
      .where(args)
      .getMultiple()
      .then(response =>
        response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      )
  )
}

function loadExtraPostData(post: WordPress.PostTypeResponse): PublicSite_CustomPageData {
  let posts = Map<number, AsyncState<WordPress.PostTypeResponse>>()
  let latest_articles = unloadedAsyncState<Array<WordPress.PostTypeResponse>>()
  let news: WordPress.Overview<'news'>;
  let stories: WordPress.Overview<'story'>;
  const searchParams: URLSearchParams = new URL(location.href).searchParams

  var params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  let category = params.category as any
  let year = params.year as any

  const currentPage = searchParams.has('page') ? parseInt(searchParams.get('page')) : 1

  const reqArgs = {
    per_page: 12,
    page: currentPage
  }

  if (post.type == 'page' && post.template == 'news-overview') {

    const categoryFilter = {
      news_taxonomy: category
    }
    const yearFilter: WordPress.PostRequestArguments = year ? {
      after: `${year}-01-01T00:00:00+01:00`,
      before: `${parseInt(year)+1}-01-01T00:00:00+01:00`
    } : {}

    news = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'news',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('news_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      years: loadingAsyncState<Array<number>>(_ =>
        WordPress.api<number>()
          .years('news')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.NewsArticleResponse>()
          .select('news')
          .where({
            ...reqArgs,
            ...categoryFilter,
            ...yearFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'news',
                posts: response.data
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  if (post.type == 'page' && post.template == 'story-overview') {
    const categoryFilter = {
      story_taxonomy: category
    }

    stories = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'story',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('story_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.StoryResponse>()
          .select('story')
          .where({
            ...reqArgs,
            ...categoryFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'story',
                posts: response.data,
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  return {
    posts,
    post,
    latest_articles,
    stories,
    news
  }
}

export const InitPagesStates: (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = b => ({
  page: PageStateZero<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>(
    () => unloadedAsyncState(),
    defaultPage,
    pageDisplay(b)
  ).page
})

export const ERROR_PAGE_SLUG = '/not-found'

export const get_page = (
  slug: string,
  extra_parameters: ExtraParameters
): AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>> =>
  loadingAsyncState(_ => {
    slug = removeLangFromSlug(slug, lang)

    var params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (params.preview || params.preview_id) {

      let preview_id = params.preview_id || params.page_id || params.p
      slug = `/previews/${preview_id}`
    }

    return WordPress.api()
      .current(slug)
      .then(response => {
        if (response.data.type == 'redirect') {
          window.location.href = response.data.to
          return { kind: 'result', status: 301, to: response.data.to }
        }
        return response.data && response.data.acf
          ? {
            kind: 'result',
            value: {
              blocks: response.data.blocks_custom ? response.data.blocks_custom.map(b => TransformStandardBlock(b)) : [],
              extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
            },
            status: 200
          }
          : { kind: 'failed', status: 404 }
      })
      .catch(e => {
        if (slug != ERROR_PAGE_SLUG) {
          return WordPress.api()
            .current(ERROR_PAGE_SLUG)
            .then(response => {
              if (response.data.type == 'redirect') {
                window.location.href = response.data.to
                return { kind: 'result', status: 301, to: response.data.to }
              }
              return response.data && response.data.acf
                ? {
                  kind: 'result',
                  value: {
                    blocks: response.data.blocks_custom ? response.data.blocks_custom.map(b => TransformStandardBlock(b)) : [],
                    extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
                  },
                  status: 200
                }
                : { kind: 'failed', status: 404 }
            })
            .catch(e2 => {
              console.error(e2)
              return e2
            })
        }
        else {
          console.error(e)
          return e
        }
      })
  })

export function get_options(id: string): AsyncState<WordPress.OptionsResponse> {
  return loadingAsyncState<WordPress.OptionsResponse>(_ =>
    WordPress.api()
      .options(id)
      .then(response => {
        return response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      })
  )
}

const getPost = (id: number) =>
  WordPress.api()
    .anypost(id)
    .then(response => {
      console.log('response', response)
      return response.data
        ? ({ kind: 'result', status: 200, value: response.data } as any)
        : {
          kind: 'failed',
          status: 404
        }
    })
    .catch(e => {
      console.log(e)
      return { kind: 'failed', status: 500 } as any
    })

export const application = (
  data: { rootpath: string; rootpath_to_ignore: string; login_address?: string },
  regionSwitcher: (_:RegionSwitchState ) => Widget<Action<RegionSwitchState>>,
  header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>>,
  footer: (
    _: AppState<PublicSiteState, PublicSiteCustomRoutes>
  ) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>,
  errorPage: IOWidget<PublicSiteState, never>,
  loadingPage: Widget<never>,
  page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>,
  custom_pages: CustomPages
) => {
  lang = window.wp.language;
  let rootpath = data.rootpath ? data.rootpath : ''
  let rootpath_to_ignore = data.rootpath_to_ignore ? data.rootpath_to_ignore : ''

  return (s0: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
    return browserRouter<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
      s0.route.kind == 'ignore'
        ? nothing()
        : any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()([
          async<WordPress.OptionsResponse>(_ => nothing())(s0.state.options).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >(a => s => {
            let s1 = a(s.state.options)

            return s1.kind == 'loaded'
              ? {
                ...s0,
                state: {
                  ...s0.state,
                  options: s1
                }
              }
              : s0
          }),

          s0.state.page.page.kind == 'loaded'
            ? async<Array<WordPress.PostTypeResponse>>(_ => nothing())(
              s0.state.page.page.value.extra_data.latest_articles
            ).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          latest_articles: a(s.state.page.page.value.extra_data.latest_articles)
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.news.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            async: a(s.state.page.page.value.extra_data.news.async)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),

            s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview' &&
            s0.state.page.page.value.extra_data.news.kind == 'news'
            ? async<Array<number>>(_ => nothing())(s0.state.page.page.value.extra_data.news.years).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            years: a(s.state.page.page.value.extra_data.news.kind == 'news' ? s.state.page.page.value.extra_data.news.years : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
            s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview' &&
            s0.state.page.page.value.extra_data.news.kind == 'news'
            ? async<Array<WordPress.TaxonomyResponse>>(_ => nothing())(s0.state.page.page.value.extra_data.news.categories).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            categories: a(s.state.page.page.value.extra_data.news.kind == 'news' ? s.state.page.page.value.extra_data.news.categories : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),


          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'story-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.stories.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          stories: {
                            ...s.state.page.page.value.extra_data.stories,
                            async: a(s.state.page.page.value.extra_data.stories.async)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
            s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'story-overview' &&
            s0.state.page.page.value.extra_data.stories.kind == 'story'
            ? async<Array<WordPress.TaxonomyResponse>>(_ => nothing())(s0.state.page.page.value.extra_data.stories.categories).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          stories: {
                            ...s.state.page.page.value.extra_data.stories,
                            categories: a(s.state.page.page.value.extra_data.stories.kind == 'story' ? s.state.page.page.value.extra_data.stories.categories : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
          any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
            s0.state.page.page.kind == 'loaded'
              ? s0.state.page.page.value.extra_data.posts
                .map((p, key) =>
                  async<WordPress.PostTypeResponse>(_ => nothing())(p).map<
                    Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
                  >(a => s => {
                    if (s.state.page.page.kind != 'loaded') return s
                    let a1 = a(s.state.page.page.value.extra_data.posts.get(key))
                    return {
                      ...s,
                      state: {
                        ...s.state,
                        page: {
                          ...s.state.page,
                          page: {
                            ...s.state.page.page,
                            value: {
                              ...s.state.page.page.value,
                              extra_data: {
                                ...s.state.page.page.value.extra_data,
                                posts: s.state.page.page.value.extra_data.posts.set(key, a1)
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                )
                .valueSeq()
                .toArray()
              : [nothing()]
          ),
          regionSwitcher(s0.state.regionSwitch).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(
            a => s1 => ({
              ...s1,
              state: { ...s1.state, regionSwitch: a(s1.state.regionSwitch) }
            })
          ),
          header(s0.state.header, s0.state.options).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(
            a => s1 => ({
              ...s1,
              state: { ...s1.state, header: a(s1.state.header) }
            })
          ),
          EntryClient<
            CustomBlockData,
            CustomBlock,
            Block,
            PublicSiteState,
            keyof CustomPages,
            PublicSiteCustomRoutes,
            ExtraImages,
            PublicSite_CustomPageData
          >({
            initState: emptyAppState(page),
            custom_pages,
            StandardBlockImagesLoader: WordPressBlockImagesLoader,
            StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
            errorPage: errorPage,
            loadingPage: loadingPage,
            rootpath: rootpath,
            rootpath_to_ignore: rootpath_to_ignore,
            CustomBlock_To_Widget: (
              c: CustomBlock,
              block_index: number,
              extra_data: PublicSite_CustomPageData
            ): Option<CustomBlockData> => {
              if (c.kind == 'vidda/map') {
                let map_options: Map<string, string> = Map()
                if (extra_data.extra_params) {
                  extra_data.extra_params.forEach(ps => {
                    if (ps.find(p => p.param == 'kind' && p.value == 'map')) {
                      ps.forEach(p => {
                        map_options = map_options.set(p.param, p.value)
                      })
                    }
                  })
                }
                const vidda_map: CustomBlockData = {
                  kind: 'mapBlock',
                  value: {
                    fst: {
                      addresses: get_addresses(),
                      state: frieslandcampina_corporate_map(
                        extra_data.extra_params,
                        map_options.get('city')
                      ),
                      block_index
                    },
                    snd: {
                      // styling
                    }
                  }
                }
                return some(vidda_map)
              }
              if (c.kind == 'vidda/download') {
                const vidda_download: CustomBlockData = {
                  kind: 'downloadsBlock',
                  value: {
                    fst: {
                      index: block_index,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      items: c.innerBlocks.map((downloadItem, index) => {
                        return {
                          key: index.toString(),
                          title: downloadItem.attrs.title,
                          text: downloadItem.attrs.file_name,
                          file_url: downloadItem.attrs.url
                        }
                      }),
                      useSVGIcons: false
                    },
                    snd: downloadBlockClasses as DownloadBlockStyle
                  }
                }
                return some(vidda_download)
              }

              if (c.kind == 'vidda/text') {
                const vidda_text: CustomBlockData = {
                  kind: 'textBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      text: c.attrs.text,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      has_show_more: c.attrs.has_show_more
                    },
                    snd: textBlockClasses as TextBlockStyle
                  }
                }

                return some(vidda_text)
              }

              if (c.kind == 'vidda/form') {
                let res = getFormState([], c.attrs.form_id)

                //we can implement here the mapping to translate the english names of the countries
                // let lst = []
                // for (let [key, value] of Object.entries(CountriesList.countries)) {
                //   lst.push(value.name)
                // }
                // lst = lst.sort()
                res.context.external_options = Map<string, string[]>()
                  .set("all_countries", countries_list)
                  .set('all_countries_nl', countries_list_nl)
                  .set('all_countries_de', countries_list_de)

                return some({
                  kind: 'formBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      form_id: c.attrs.form_id,
                      state: res
                    },
                    snd: formBlockClasses
                  }
                })
              }

              if (c.kind == 'vidda/table') {
                return some({
                  kind: 'tableBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      html: c.attrs.html
                    },
                    snd: tableBlockClasses
                  }
                })
              }

              if (c.kind == 'vidda/latest') {
                return some({
                  kind: 'latestBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      button: {
                        title: c.attrs.button_text,
                        url: '/updates'
                      },
                      hasBackground: c.attrs.hasBackground,
                      display:
                        c.attrs.variant == 'selected'
                          ? { kind: 'selected', ids: c.attrs.ids }
                          : { kind: 'latest' }
                    },
                    snd: {}
                  }
                })
              }

              if (c.kind == 'vidda/milk-prices-table') {
                const vidda_milk_prices_table: CustomBlockData = {
                  kind: 'milkPricesTableBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      title: c.attrs.title,
                      description: c.attrs.description,
                      kind: c.attrs.kind,
                      milk_prices: loadingAsyncState<WordPress.MilkPricesResponse>(async () => {
                        let res = await fetch(`/wp-json/acf/v3/options/options`, { method: 'get', credentials: 'include' })
                        if (!res.ok) return { kind: "failed", status: 400 }
                        let json: WordPress.MilkPricesResponse = await res.json()
                        return { kind: "result", status: 200, value: json }
                      })
                    },
                    snd: {}
                  }
                }

                return some(vidda_milk_prices_table)
              }

              if (c.kind == 'vidda/milk-prices-chart') {
                const vidda_milk_prices_chart: CustomBlockData = {
                  kind: 'milkPricesChartBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      kind: c.attrs.kind,
                      milk_prices: loadingAsyncState<WordPress.MilkPricesResponse>(async () => {
                        let res = await fetch(`/wp-json/acf/v3/options/options`, { method: 'get', credentials: 'include' })
                        if (!res.ok) return { kind: "failed", status: 400 }
                        let json: WordPress.MilkPricesResponse = await res.json()
                        return { kind: "result", status: 200, value: json }
                      })
                    },
                    snd: {}
                  }
                }

                return some(vidda_milk_prices_chart)
              }

              if (c.kind == 'vidda/media') {
                const vidda_media: CustomBlockData = {
                  kind: 'mediaBlock',
                  value: {
                    fst: c.attrs.type == 'image' ? {
                      // image: c.attrs.type == 'video' ? null : c.attrs.image,
                      type: 'image',
                      useCookieBar: false,
                      caption: c.attrs.caption,
                      image: c.attrs.image
                    } : {
                        type: 'video',
                        caption: (c.attrs.caption && c.attrs.caption.length != 0) ? c.attrs.caption : null,
                        useCookieBar: true,
                        video: {
                          id: c.attrs.video.id,
                          url: c.attrs.video.url,
                          type: c.attrs.video.type,
                          frameBorder: c.attrs.video.frameBorder,
                          allowFullScreen: c.attrs.video.allowFullScreen
                        }
                      },
                    snd: mediaBlockClasses as MediaBlockStyle
                  }
                }
                return some(vidda_media)
              }

              if (c.kind == 'vidda/link-list') {
                const vidda_link_list: CustomBlockData = {
                  kind: 'linkListBlock',
                  value: {
                    fst: {
                      index: null,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      items: c.innerBlocks.map((linkItem, index) => {
                        let link = linkWrapper({ title: linkItem.attrs.link_text, url: linkItem.attrs.link_url })
                        return {
                          key: index.toString(),
                          title: link.title,
                          url: link.url,
                          is_link_external: link.is_link_external
                        } as LinkProps
                      }),
                      useSVGIcons: false,
                    },
                    snd: null
                  }
                }
                return some(vidda_link_list)
              }

              if (c.kind == 'vidda/expandable') {
                const vidda_expandable: CustomBlockData = {
                  kind: 'expandableBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      link: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? linkWrapper({ title: c.attrs.button_text, url: c.attrs.button_url }) : null,
                      index: block_index,
                      items: c.innerBlocks.map((expandableItem, index) => {
                        return {
                          index: index,
                          key: index.toString(),
                          title: expandableItem.attrs.title,
                          open: false,
                          useSVGIcons: false,
                          blocks: expandableItem.innerBlocks.map(innerBlock => innerBlock.innerHTML)
                        }
                      })
                    },
                    snd: null
                  }
                }

                return some(vidda_expandable)
              }

              if (c.kind == 'vidda/quote') {
                const vidda_quote: CustomBlockData = {
                  kind: 'customQuoteBlock',
                  value: {
                    fst: {
                      index: block_index,
                      text: c.attrs.text,
                      author: c.attrs.author,
                      company: c.attrs.company,
                      primary_button: c.attrs.primary_button_text && c.attrs.primary_button_url
                        ? linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url })
                        : null,
                      secondary_button: c.attrs.secondary_button_text && c.attrs.secondary_button_url
                        ? linkWrapper({ title: c.attrs.secondary_button_text, url: c.attrs.secondary_button_url })
                        : null,
                      image: c.attrs.image,
                    },
                    snd: quoteBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_quote)
              }

              if (c.kind == 'vidda/iframe') {
                return some({
                  kind: 'iframeBlock',
                  value: {
                    fst: {
                      index: block_index,
                      link: c.attrs.url
                    },
                    snd: iframeBlockClasses
                  }
                } as CustomBlockData)
              }

              if (c.kind == 'vidda/header') {
                const vidda_header: CustomBlockData = {
                  kind: 'headerBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/header',
                      header_type: StringToHeaderType(c.attrs.header_type),
                      image_focus: c.attrs.image_focus ? c.attrs.image_focus : 'middle',
                      title: c.attrs.title,
                      subtitle: c.attrs.subtitle,
                      intro: c.attrs.intro,
                      image: c.attrs.image,
                      image_mobile: c.attrs.image_mobile,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      video_small: c.attrs.video_small ? c.attrs.video_small : null,
                      video_medium: c.attrs.video_medium ? c.attrs.video_medium : null,
                      video_large: c.attrs.video_large ? c.attrs.video_large : null
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_header)
              }

              if (c.kind == 'vidda/image-text') {
                const vidda_image_text: CustomBlockData = {
                  kind: 'imageTextBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/image-text',
                      image_position: c.attrs.image_position,
                      image: c.attrs.image,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_image_text)
              }

              if (c.kind == 'vidda/grid' || c.kind == 'vidda/grid-with-image') {
                const vidda_grid: CustomBlockData = {
                  kind: 'gridBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/grid',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      blocks: c.innerBlocks.map(innerBlock => {
                        return {
                          title: innerBlock?.attrs?.title,
                          intro: innerBlock?.attrs?.intro,
                          image: innerBlock?.attrs?.image,
                          link: innerBlock?.attrs?.link_url ? linkWrapper({ title: innerBlock.attrs.link_text, url: innerBlock.attrs.link_url }) : undefined
                        } as GridBlockItem
                      })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_grid)
              }

              if (c.kind == 'vidda/grid-highlights') {
                const vidda_grid: CustomBlockData = {
                  kind: 'gridHighlightsBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/grid-highlights',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button:
                        c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url
                          ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url)
                          : null,
                      secondary_button:
                        c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url
                          ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url)
                          : null,
                      blocks: c.innerBlocks.map((innerBlock) => {
                        return {
                          title: innerBlock.attrs.title,
                          intro: innerBlock.attrs.intro,
                          image: innerBlock.attrs.image,
                          link: innerBlock.attrs.link_url,
                          is_video: innerBlock.attrs.is_video,
                          has_gradient: innerBlock.attrs.has_gradient,
                          label: innerBlock.attrs.label
                        } as GridHighlightsBlockItem
                      }),
                    },
                    snd: textBlockClasses as GridHighlightsBlockStyle,
                  },
                }

                return some(vidda_grid)
              }

              if (c.kind == 'vidda/carousel') {
                const vidda_grid: CustomBlockData = {
                  kind: 'carouselBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/carousel',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      show_random_items: c.attrs.show_random_items,
                      primary_button:
                        c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url
                          ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url)
                          : null,
                      secondary_button:
                        c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url
                          ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url)
                          : null,
                      blocks: c.innerBlocks.map((innerBlock) => {
                        return {
                          title: innerBlock.attrs.title,
                          intro: innerBlock.attrs.intro,
                          image: innerBlock.attrs.image,
                          link: innerBlock.attrs.link_url,
                          is_video: innerBlock.attrs.is_video,
                          label: innerBlock.attrs.label,
                        } as CarouselBlockItem
                      }),
                    },
                    snd: carouseBlockClasses,
                  },
                }

                return some(vidda_grid)
              }

              if (c.kind == 'vidda/facts-and-figures') {
                const vidda_facts_and_figures: CustomBlockData = {
                  kind: 'factsAndFiguresBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/facts-and-figures',
                      items: c.innerBlocks.map(item => { return { amount: item.attrs.amount, label: item.attrs.label, intro: item.attrs.intro } })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_facts_and_figures)
              }
              if (c.kind == 'vidda/cta') {
                const vidda_cta: CustomBlockData = {
                  kind: 'ctaBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/cta',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      image: c.attrs.image,
                      image_position: c.attrs.image_position,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: ctaBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_cta)
              }

              if (c.kind == 'vidda/image-stack') {
                const vidda_image_stack: CustomBlockData = {
                  kind: 'imageStackBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      blockName: 'vidda/image-stack',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_image_stack)
              }

              if (c.kind == 'vidda/attention') {
                const vidda_image_stack: CustomBlockData = {
                  kind: 'attentionBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/attention',
                      title: c.attrs.title,
                      image: c.attrs.image,
                      link: c.attrs.link_text && c.attrs.link_url ? linkWrapper({title: c.attrs.link_text, url: c.attrs.link_url}) : null
                    },
                    snd: textBlockClasses as QuoteBlockStyle,
                  },
                }

                return some(vidda_image_stack)
              }

              if (c.kind == 'vidda/gallery') {
                const vidda_image_gallery: CustomBlockData = {
                  kind: 'imageGalleryBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/gallery',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
                    },
                    snd: textBlockClasses as ImageGalleryBlockStyle
                  }
                }

                return some(vidda_image_gallery)
              }

              if (c.kind == 'vidda/featured-content') {
                const vidda_featured_content: CustomBlockData = {
                  kind: 'featuredContentBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/featured-content',
                      label: c.attrs.label,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      button: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? createButtonData(c.attrs.button_text, c.attrs.button_url) : null,
                      image_position: c.attrs.image_position,
                      image: c.attrs.image
                    },
                    snd: null
                  }
                }

                return some(vidda_featured_content)

              }
              if (c.kind == 'vidda/steps') {
                const vidda_steps_block: CustomBlockData = {
                  kind: 'stepsBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/steps',
                      index: block_index,
                      image: c.attrs.image,
                      title: c.attrs.title,
                      blocks: c.innerBlocks.map(innerBlock => {
                        return {
                          attrs: {
                            title: innerBlock.attrs.title,
                            text: innerBlock.attrs.content
                          }
                        }
                      }),
                      primary_button: c.attrs.show_primary_button ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary_button ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: textBlockClasses as StepsBlockStyle
                  }
                }

                return some(vidda_steps_block)
              }
              if (c.kind == 'vidda/barometer') {
                const vidda_steps_block: CustomBlockData = {
                  kind: 'barometerBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/barometer',
                      index: block_index,
                      title: c.attrs.title,
                      text: c.attrs.text,
                      graphs: c.innerBlocks.map((graph, index) => {
                        return {
                          key: index.toString(),
                          label: graph.attrs.label,
                          target_label: graph.attrs.target_label,
                          current: graph.attrs.current,
                          target: graph.attrs.target,
                          min: graph.attrs.min,
                          max: graph.attrs.max
                        } as GraphProps
                      }),

                    },
                    snd: textBlockClasses as BarometerBlockStyle
                  }
                }

                return some(vidda_steps_block)
              }

              return none()
            },
            CustomBLockImagesLoader: (c: CustomBlock) => {
              // if (c.kind == 'exampleBlock') {
              //   //let img = mk_pair(c.image, loadMedia(c.image) as AsyncState<Map<ImageSize<ExtraImages>, Url>>)
              //   //improve when personBlock is ready in drupal/parsed_types
              //   return []
              // }
              return []
            }
          })(s0),
          // s0.state.latest_updates.kind == 'loaded' ?
          //   LatestBlock(
          //     {
          //       title: 'Laatste updates',
          //       button: {
          //         title: 'Bekijk alle updates',
          //         url: '/updates'
          //       },
          //       hasBackground: false,
          //       display: { kind: 'latest' }
          //     },
          //     { style: {} }
          //   )({} as CMSState<{}, {}, never>)

          //   latestUpdates(s0.state.latest_updates).never()
          // : nothing(),
          footer(s0).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s1 => a(s1)),
          history().map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(la => {
            la.action == 'PUSH' && window.scrollTo(0, 0)
            return closeSearchAndMenu
          }),
          sidenote<AppState<PublicSiteState, PublicSiteCustomRoutes>>(

          )(_ => nothing())(s0)
        ])
    ).map<AppState<PublicSiteState, PublicSiteCustomRoutes>>(a => {
      let s1 = a(s0)

      if( s1.state.page.page.kind == "loaded" && s0.state.page.page.kind != "loaded") {
        s1.state.page.display = page(mk_pair(List(), some(s1.state.page.page.value.extra_data.post)))
      }

      if (s0.route != s1.route) {
        s1 = closeSearchAndMenu(s1)
      }

      if (
        s1.state.page.page.kind == 'loaded' &&
        s1.state.page.page.value.extra_data.post.yoast &&
        s1.state.page.page.value.extra_data.post.yoast.title
      ) {
        document.title = unescapeHTML(s1.state.page.page.value.extra_data.post.yoast.title)
      }

      s1.state.header.menu == 'open' ?
        document.documentElement.classList.add('menu--open')
      : document.documentElement.classList.remove('menu--open')

      if (s1.state.header.menu == 'open' || s1.state.header.showSearchBar) {
        document.body.setAttribute('data-scroll', 'locked')
      } else {
        document.body.setAttribute('data-scroll', '')
      }

      if(s1.route != s0.route){
        document.getElementsByClassName("header")[0].scrollIntoView()
      }
      return s1
    })
  }
}
